namespace $.$$ {
	const $shm_hitalama_codex_map_resized = Symbol( '$shm_hitalama_codex_map_resized' )

	export class $shm_hitalama_codex_map extends $.$shm_hitalama_codex_map {

		override Sessions_pick() {
			const pick = super.Sessions_pick()
			pick.trigger_content = ()=> [ this.Sessions_icon() ]
			return pick
		}

		override Chat_page() {
			const page = super.Chat_page()
			if( ( page as any )[ $shm_hitalama_codex_map_resized ] ) return page
			;( page as any )[ $shm_hitalama_codex_map_resized ] = true
			const sub = page.sub.bind( page )
			const style = page.style.bind( page )
			page.sub = ()=> [ ... sub(), this.Side_resizer() ]
			page.style = ()=> ({ ... style(), position: 'relative', width: this.width_px(), flexBasis: this.width_px() })
			return page
		}

		agent_config( next?: string ) {
			return this.$.$shm_hitalama_settings.agent_config_current( next )
		}

		agent_config_dictionary() {
			return Object.fromEntries(
				this.$.$shm_hitalama_settings.agent_configs().map( config => [ config.id, config.name ] ),
			)
		}

		map_id() {
			return this.$.$mol_state_arg.value( 'map' ) ?? ''
		}

		map() {
			const id = this.map_id()
			if( !id ) return null
			return $giper_baza_glob.Pawn( new $giper_baza_link( id ), $shm_hitalama_map )
		}

		width_px() {
			return `${ this.width() }px`
		}

		server_url( next?: string ) {
			const url = this.$.$shm_hitalama_settings.agent_url().trim()
			if( !url ) throw new Error( 'Для Codex не задан URL моста' )
			this.$.$shm_codex_api.token_provider( url, ()=> this.$.$shm_hitalama_settings.agent_token() )
			return url
		}

		session_prefix() {
			return this.map_id()
				? `[map:${ this.map_id() }] `
				: `[general:${ this.general_profile_id() }] `
		}

		general_profile_id() {
			return this.$.$shm_hitalama_profile.current()?.link().str || 'local'
		}

		agent_storage_namespace() {
			const scope = this.map_id() || `general_${ this.general_profile_id() }`
			return `codex_map_${ this.$.$shm_hitalama_settings.agent_config_current() }_${ scope }`
		}

		agent_sessions_load( refresh = 0 ) {
			return $mol_wire_sync( $shm_codex_api ).sessions(
				this.server_url(), refresh, this.session_prefix(),
			)
		}

		session_visible( session: $shm_codex_api_thread ) {
			return Boolean( session.name?.startsWith( this.session_prefix() ) )
		}

		events_prefixes() {
			return this.session_prefix()
		}

		event_visible( event: any ) {
			const thread = event.params?.threadId || event.params?.thread?.id
			if( !thread ) return true
			if( event.params?.thread ) return this.session_visible( event.params.thread )
			return this.$.$mol_error_fence(
				()=> Boolean( ( this as any ).session_by_id( thread ) ),
				()=> false,
				()=> false,
			)
		}

		session_title( id: string ) {
			const session = ( this as any ).session_by_id( id ) as $shm_codex_api_thread | undefined
			const title = session?.name || session?.preview || `Сессия ${ id.slice( 0, 8 ) }`
			return title.startsWith( this.session_prefix() ) ? title.slice( this.session_prefix().length ) : title
		}

		session_id( next?: string ) {
			const scope = this.map_id() || `general:${ this.general_profile_id() }`
			const key = `shm_hitalama_codex_map_session:${ this.$.$shm_hitalama_settings.agent_config_current() }:${ scope }`
			if( next !== undefined ) return this.$.$mol_state_local.value( key, next ) ?? ''
			const stored = this.$.$mol_state_local.value< string >( key ) ?? ''
			if( stored || this.map_id() ) return stored
			return ( this as any ).sessions_data()[0]?.id || ''
		}

		session_create_name( title: string ) {
			return `${ this.session_prefix() }${ title }`
		}

		map_context_data( session_id: string ) {
			const map = this.map()
			if( !map ) throw new Error( 'Откройте карту для работы Codex' )
			const app = this.$.$shm_hitalama_app.Root(0) as $.$$.$shm_hitalama_app
			return {
				session_id,
				client_id: app.mcp_client().client_id(),
				map_id: map.link().str,
				map_title: map.title(),
				url: this.$.$mol_dom_context.document?.location.href ?? '',
			}
		}

		map_context_prompt( session_id: string ) {
			const context = this.map_context_data( session_id )
			return [
				this.$.$shm_hitalama_skills_agent.prompt(),
				'Контекст Hitalama карты:',
				`session_id: ${ context.session_id }`,
				`client_id: ${ context.client_id }`,
				`map_id: ${ context.map_id }`,
				`map_title: ${ context.map_title }`,
				'Используй MCP-сервер hitalama для чтения и изменения карты.',
				'Во все hitalama tools передавай session_id, client_id и map_id из этого контекста.',
			].join( '\n' )
		}

		session_create_instructions() {
			if( this.$.$mol_state_arg.value( 'section' ) === 'applications' ) return this.$.$shm_hitalama_components_agent.prompt( this.$.$shm_hitalama_app.Root(0) as $.$$.$shm_hitalama_app )
			if( !this.map() ) return 'Ты общий агент Hitalama. Карта не открыта; контекст карты не задан.\n' + this.$.$shm_hitalama_skills_agent.prompt()
			const context = this.map_context_data( '' )
			return [
				'Ты работаешь с картой Hitalama через MCP-сервер hitalama.',
				this.$.$shm_hitalama_skills_agent.prompt(),
				`client_id: ${ context.client_id }`,
				`map_id: ${ context.map_id }`,
				`map_title: ${ context.map_title }`,
				'Перед изменениями сначала прочитай контекст карты. Для вызовов инструментов передавай client_id, map_id и session_id из контекста текущего сообщения.',
			].join( '\n' )
		}

		session_context_register( session_id: string ) {
			if( !this.map() ) return null
			const context = this.map_context_data( session_id )
			return $mol_wire_sync( this.$.$shm_hitalama_mcp_context ).register(
				this.$.$shm_hitalama_settings.agent_mcp_url(),
				this.$.$shm_hitalama_settings.agent_mcp_token(),
				context.session_id,
				context.client_id,
				context.map_id,
				context.map_title,
				context.url,
			)
		}

		async agent_session_create_async(
			title: string,
			cwd: string,
			instructions: string,
			settings: { model?: string, serviceTier?: string | null } = {},
		) {
			const result = await $shm_codex_api.create_session(
				this.server_url(), title, cwd, instructions, settings,
			)
			await $mol_wire_async( this ).session_context_register( result.thread.id )
			return result
		}

		agent_message_send(
			id: string,
			text: string,
			attachments: readonly $shm_agent_attachment[],
			mode: 'start' | 'queue' | 'steer',
			client_message_id: string,
		) {
			this.session_context_register( id )
			return $mol_wire_sync( $shm_codex_api ).send_with_images(
				this.server_url(), id, text, attachments, mode, client_message_id,
				this.$.$mol_state_arg.value( 'section' ) === 'applications'
					? this.$.$shm_hitalama_components_agent.prompt( this.$.$shm_hitalama_app.Root(0) as $.$$.$shm_hitalama_app )
					: this.map() ? this.map_context_prompt( id ) : this.$.$shm_hitalama_skills_agent.prompt(),
			)
		}

	}

}
